<template>
    <div class="thanks-props">
        <h2 class="thanks-props__title">
            {{ messages.orderDetails }}
        </h2>
        <ThanksPropsBlock>
<!--            <template #title>-->
<!--                {{ messages.contactDetails }}-->
<!--            </template>-->
            <div v-for="item in getPropsBlock('contact')">
                <p>{{ item.name }}</p>
                <p>{{ item.value }}</p>
            </div>
        </ThanksPropsBlock>
        <ThanksPropsBlock v-if="delivery">
<!--            <template #title>-->
<!--                {{ messages.paymentData.delivery }}-->
<!--            </template>-->
            <div>
                <p>
                    {{ messages.payMethod }}
                </p>
                <p>{{ delivery.printName }}</p>
            </div>
            <div v-for="item in getPropsBlock('delivery')">
                <p>{{ item.name }}</p>
                <p>{{ item.value }}</p>
            </div>
        </ThanksPropsBlock>
        <ThanksPropsBlock>
<!--            <template #title>-->
<!--                {{ messages.payment }}-->
<!--            </template>-->
            <div v-for="item in result.order.allPaySystems">
                <p>
                    {{ messages.payMethod }}
                </p>
                <p>
                    {{ item.printName }}
                </p>
            </div>
        </ThanksPropsBlock>
        <ThanksPropsBlock>
<!--            <template #title>-->
<!--                {{ messages.recipient }}-->
<!--            </template>-->
            <div v-for="item in getRecipient">
                <p>{{ item.name }}</p>
                <p>
                    {{ item.value }}
                </p>
            </div>
        </ThanksPropsBlock>
    </div>
</template>

<script>
import ThanksPropsBlock from "./ThanksPropsBlock";
export default {
    name: 'ThanksProps',
    props: ['result'],
    components: {
        ThanksPropsBlock
    },
    computed: {
        delivery() {
            return this.result.order.delivery;
        },
        messages() {
            return this.result.order.messages;
        },
        properties() {
            return this.result.order.properties;
        },
        /**
         * Быть аккуратным с данным методом , т.к. при смене порядка отображения инпутов (Фамилия,Имя) будет заменяться наоборот
         * @returns {*}
         */
        getRecipient() {
            let recipient = this.properties?.find(el => el.code === 'RECIPIENT');
            let user = this.getPropsBlock('user');

            switch (recipient.value) {
                case 'Покупатель' :
                    return user;
                default :
                    let spl = recipient.value.split(',')
                    user = user.map((el, ind) => {
                        return {
                            ...el,
                            value: spl[ind],
                        };
                    })
                    return user
            }
        }

    },
    methods: {
        getPropsBlock(block) {
            /**
             * https://jira.aniart.com.ua/browse/SOVA2-226
             * @type {{contact: string[]}}
             */
            const blocks = {
                user: ['USER_LAST_NAME', 'USER_NAME', 'PHONE'],
                contact: ['USER_LAST_NAME', 'USER_NAME', 'PHONE', 'EMAIL', 'CERTIFICATE', 'SOVA_CLUB'],
                delivery: ['CITY', 'NP_DEPARTMENT', 'STORE_ADDRESS', 'STREET', 'HOUSE', 'APARTMENT'],
            }
            return this.properties.filter(el => {
                return blocks[block].includes(el.code) && el.value
            })
        },

    }


    // mounted()
}
</script>

<style lang="scss" scoped>
.thanks-props {
    display: grid;
    grid-row-gap: 24px;
    @include point-md {
        grid-row-gap: 32px;
    }

    &__title {
        font-weight: 500;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        font-size: 16px;
        @include point-lg{
            font-size: 18px;
        }
    }

    :deep(.thanks-props-block) {
        &:not(:last-child) {
            margin-bottom: 24px;
            @include point-md {
                margin-bottom: 32px;
            }
        }
    }
}
</style>